export const getUserInfo = function () {
    let userInfo = localStorage.getItem('userInfo')
    // 优先使用 sessionStorage 中的用户信息
    if (sessionStorage.getItem('userInfo')) {
        userInfo = sessionStorage.getItem('userInfo')
    }
    userInfo = userInfo ? JSON.parse(userInfo) : null
    if (userInfo) {
        const status = parseInt(+new Date() - (userInfo.timeStamp || 0))
        if (status > 3 * 24 * 60 * 60 * 1000) {
            clearUserInfo()
            return null
        }
    }
    return userInfo
}

export const setUserInfo = function (info) {
    let userInfo = localStorage.getItem('userInfo') || JSON.stringify({})
    userInfo = { ...JSON.parse(userInfo), ...info, timeStamp: +new Date() }
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
    return userInfo
}

export const clearUserInfo = function () {
    localStorage.removeItem('userInfo')
}

export const mAuthUserInfo = function () {
    clearUserInfo()
    window.sessionStorage.setItem('showPage', true)
    const redirect_uri = encodeURIComponent(window.location.href)
    const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${window.WX_APPID}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
    window.location.replace(url)
}

// getWechatCode('https://kj.peki.vip/', 'wx472a9a3910105a77')
export const getWechatCode = function (url, appId) {
    const redirect_uri = encodeURIComponent(url)
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
}

export const wxLogin = function (ticket) {
    // 过滤 参数中的tpTicket
    // const url = window.location.href
    // const list = url.split('&')
    // const newList = []
    // list.forEach(item => {
    //     if (item.split('=')[0] !== 'tpTicket') {
    //         newList.push(item)
    //     }
    // })
    // const newUrl = newList.join('&')
    clearUserInfo()
    const redirectUrl = encodeURIComponent(window.location.href)
    const url = `https://kj.peki.vip/wx-login/index.html?ticket=${ticket}&redirectUrl=${redirectUrl}`
    window.location.replace(url)
}

export const scanQrcode = function (ticket) {
    return `https://kj.peki.vip/wx-login/index.html?ticket=${ticket}`
}
